$(document).ready(function() {
	var parent_node = document.querySelector('.glossary');
	if(!parent_node) return false;
	
	var glossary_group = document.querySelectorAll(".glossary-list-group");
	var glossary_index = document.querySelectorAll(".glossary-lettermark");
	var glossary_sort = document.querySelector("#sortGlossaryByCategory");
	var glossary_word = document.querySelectorAll(".glossary-description");
	
	function init(){
		// responsive
		resetScreen();
		mql.maxSm.addListener(resetScreen);

		// sort event
		sort();

		for(var idx = 0; idx < glossary_index.length; idx++){
			// index setting
			indexActiveCheck(glossary_index[idx]);
			// bundle event
			var group = [];
			group[idx] = new Bundle(glossary_group[idx]);
			group[idx].init();
		}
	}
	// mobile 
	function resetScreen(){
		var $setTarget = $(glossary_group).find(".glossary-description-bundle");
		var $btn = $(glossary_group).find(".btn-toggle");

		if (mql.maxSm.matches) {
			$setTarget.addClass("collapse");
			$btn.attr("aria-expanded", "false");
			$setTarget.removeClass("show");
			$(".glossary-list-group:visible").eq(0).find(".glossary-description-bundle").addClass("show").siblings().find(".btn-toggle").attr("aria-expanded", "true");
		} else {
			$setTarget.removeClass("collapse show");
			$btn.attr("aria-expanded", "true");
		}
	}
	// sort
	function sort(){
		// option select
		$(glossary_sort).on("change", function(){
			var selectedValue = $(this).find("option:selected").attr("class");
			// all
			if( selectedValue === "all" ){
				$(glossary_word).addClass("active");
			// case by case
			}else {
				$(glossary_word).each(function(){
					var classList = $(this).attr("class");
					if(classList.indexOf(selectedValue) > 0){
						$(this).addClass("active");
					}else{
						$(this).removeClass("active");
					}
				});
			}
			// refresh index
			$(glossary_index).each(function(){
				indexActiveCheck(this);
			});
			// refresh bundle
			resetScreen();
		});
	}
	// index
	function indexActiveCheck(element_node){
		var $this = $(element_node);
		var givenId = $this.data("id");
		var letterText = $this.text();
		
		var p = indexActiveCheck.prototype;

		p.focusableHTML = function(id, text){
			return ("<a href=#"+ id +">"+ text +"</a>");
		};
		p.dimedHTML = function(text){
			return ("<span>"+ text +"</span>");
		};
		p.circuit = function(){
			var matchGroupHead = $(glossary_group).find("[id="+ givenId +"]");
			var matchGroup = matchGroupHead.closest(".glossary-list-group");

			if( matchGroupHead.length > 0 && matchGroup.find(".glossary-description.active").length > 0){
				$this.removeClass("disable").html(p.focusableHTML(givenId, letterText));
				matchGroup.addClass("active");
				return false;
			}else{
				$this.addClass("disable").html(p.dimedHTML(letterText));
				matchGroup.removeClass("active");
			}
		};
		p.circuit();
	}
	// bundle
	function Bundle(element_node){
		var $this = $(element_node);
		var $content = $this.find(".glossary-description-bundle");

		var p = Bundle.prototype;
		p.init = function(){
			p.eventLitsener();
		};
		p.eventLitsener = function(){
			$this.find(".btn-toggle").on("click", function(){
				p.accessibility($(this));
				p.toggleEvent($content);
			});
			p.backToTop();
		};
		p.accessibility = function($target){
			if($target.attr("aria-expanded") === "true"){
				$target.attr("aria-expanded", "false");
			}else{
				$target.attr("aria-expanded", "true");
			}
		};
		p.toggleEvent = function(tg){
			tg.collapse("toggle");
		};
		p.backToTop = function(){
			$this.siblings().find(".btn-back-to-top").on("click", function(e){
				e.preventDefault();
				$("html").stop().animate({
					scrollTop : 0
				}, 600);
			});
		};
	}
	init();
});